import { axios } from '@/services/axios';

export const deleteTRSNode = (nodeId) => {
    const endpoint = `/TRSNode/${nodeId}`;
    const res = axios.delete(endpoint);
    return res;
};
